import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function NotFound() {
  useEffect(() => {
    const m = document.createElement("meta");
    m.name = "robots";
    m.content = "noindex";
    document.head.appendChild(m);
    return () => m.remove();
  }, []);
  return (
    <main data-testid="page-notfound" className="container-narrow py-32 text-center">
      <div className="text-[12px] tracking-[0.22em] uppercase text-gold-500 font-medium">
        404
      </div>
      <h1 className="font-serif-display text-4xl md:text-6xl text-navy-800 mt-3">
        We couldn’t find that page.
      </h1>
      <p className="mt-4 text-slate-600 max-w-xl mx-auto">
        The link may have moved or expired. Let’s get you back to a useful
        place.
      </p>
      <Link
        to="/"
        data-testid="notfound-home"
        className="btn-primary mt-8 inline-flex"
      >
        <ArrowLeft size={16} /> Back to Home
      </Link>
    </main>
  );
}
